import React from 'react';
import './Result.css';

const Result = ({ result }) => {
  if (!result) return null;
  return (
    <div className="result-block">
      <div className="result-title">Estimated Cost</div>
      <div className="result-value">${result.cost.toFixed(6)}</div>
      <div className="result-details">
        <span>Input Tokens: <b>{result.inputTokens}</b></span>
        <span>Output Tokens: <b>{result.outputTokens}</b></span>
        <span>Model: <b>{result.model}</b></span>
      </div>
    </div>
  );
};

export default Result; 